export const PROJECT_LIST_PAGE_TYPE = {
  PORTFOLIO: 'PORTFOLIO',
  PROJECT_LINK: 'PROJECT_LINK'
};
